package ui.app.rss.channel


import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.unit.*
import common.frontend.api.*
import compose.assets.*
import compose.assets.svg.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.utils.*
import tools.*
import ui.app.rss.*
import ui.widget.*

@ComposableNavNode(AppRssListingArgs::class)
@Composable
fun AppRssListingChannelUI() {
    with(AppRssListingChannelScope.remember()) {
        when (val state = vm.state) {
            is DataState.Error -> ErrUI()
            is DataState.Idle,
            is DataState.Loading -> LoadingUI()

            is DataState.Result -> Content(state.nnvl)
        }

    }
}

@OptIn(ExperimentalFoundationApi::class)
@Composable
private fun AppRssListingChannelScope.Content(nnvl: AppRssListingChannelScope.Wrapper) {

    val stateHorizontal = rememberScrollState(0)
    val itemMeasurer = AppRssListingChannelScope.headerSpecs.rememberMeasurer()
    val rssCreatorDialogState = DialogState.remember()

    RssChannelCreatorDialog(rssCreatorDialogState)

    Column(Modifier.fillMaxSize().padding(top = 8.dp).padding(start = 8.dp)) {
        HomeSearchUI(vm.searchFiled, label = Res.string.layer_bottom_rss_channels_search)
        Space(8.dp)
        Box(
            Modifier.fillMaxSize()
        ) {
            Box(
                Modifier.fillMaxSize()
                    .tableMeasurer(itemMeasurer)
                    .horizontalScroll(stateHorizontal)
            ) {
                LazyColumn(
                    contentPadding = PaddingValues(end = 8.dp),
                    modifier = Modifier.fillMaxHeight()
                        .width(itemMeasurer.rowWidth)
                ) {
                    stickyHeader {
                        ListingHeader(AppRssListingChannelScope.headerSpecs)
                    }
                    itemsIndexed(
                        SearchWrapper.use(
                            fields = arrayOf(
                                Io.ListingRssChannel.Item::id,
                                Io.ListingRssChannel.Item::idHex,
                                Io.ListingRssChannel.Item::name,
                                Io.ListingRssChannel.Item::url
                            ),
                            items = nnvl.state,
                            query = vm.searchFiled,
                            sort = compareByDescending { it.data.id }
                        )) { _, item ->
                        ListingDivider()
                        val rssEditorDialogState = DialogState.remember(key = item.key)
                        RssChannelEditDialog(rssEditorDialogState, item)
                        ListingItem(item, AppRssListingChannelScope.headerSpecs) {
                            rssEditorDialogState.show()
                        }
                    }
                    ListingFooter()
                }
            }

            HorizontalScrollbar(
                modifier = Modifier
                    .align(Alignment.BottomStart)
                    .padding(bottom = 8.dp)
                    .fillMaxWidth(),
                adapter = rememberScrollbarAdapter(stateHorizontal)
            )

            FloatingActionButton(
                content = { Icon(Svg.Plus, null) },
                onClick = { rssCreatorDialogState.show() },
                modifier = Modifier.align(Alignment.BottomEnd)
                    .padding(8.dp)
            )
        }
    }
}

